import React from 'react'
import { Form, Input } from 'antd'
import AceEditor from 'react-ace'

import 'brace/mode/json'
import 'brace/theme/xcode'

import CompileTemplateIcon from '../../../../../../reusables/components/compile-template-icon'
import MemoryStore from '../../../../../../utils/memory-store'

class LDAPRouteModifyDn extends React.Component {
  constructor(props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      entry: props.entry.routeData,
      controls: props.entry.routeData.controls || ''
    }

    // Bindings
    this.onFieldChange = this.onFieldChange.bind(this)
  }

  onFieldChange (key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.entry.routeData[key] = value.trim()
  }

  render () {
    return (
      <div>
        <Form.Item>
          <span style={{ color: 'red' }}>* </span>
          {'DN '}
          <CompileTemplateIcon />
          <Input
            name='dn'
            placeholder='Distinguished name'
            disabled={this.props.disabled}
            defaultValue={this.state.entry.dn}
            onChange={e => {
              this.onFieldChange('dn', e.target.value)
            }}
          />
        </Form.Item>
        <Form.Item>
          <span style={{ color: 'red' }}>* </span>
          {'New DN '}
          <CompileTemplateIcon />
          <Input
            name='newDn'
            placeholder='New Distinguished name'
            disabled={this.props.disabled}
            defaultValue={this.state.entry.newDn}
            onChange={e => {
              this.onFieldChange('newDn', e.target.value)
            }}
          />
        </Form.Item>
        <Form.Item>
          <h3>Controls <CompileTemplateIcon /></h3>
          <AceEditor
            showPrintMargin={false}
            readOnly={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
            cursorStart={1}
            mode='json'
            theme='xcode'
            style={{ width: '100%', height: 300 }}
            name='aceEditor'
            value={this.state.controls}
            setOptions={{
              showLineNumbers: true,
              newLineMode: 'unix'
            }}
            onChange={value => {
              this.onFieldChange('controls', value)
              this.setState({ controls: value })
            }}
          />
        </Form.Item>
      </div>
    )
  }
}

export default LDAPRouteModifyDn
